import { useEffect } from 'react';

import BackButton from 'components/BackButton';
import { DirectoryHeader } from 'components/DirectoryHeader/DirectoryHeader';

import { storageKeys } from 'config/settings.json';

import { getRawLocalStorage } from 'helpers/getRawLocalStorage';

import { useFeatureFlag } from 'hooks/useFeatureFlag';

import clsx from 'clsx';
import i18n from 'i18n-react';

interface AppInfoStorage {
  directoryURL?: string;
}

interface LangStorage {
  langFile?: string;
}

function LegacyDirectory() {
  const enableHeaderCompatibilityFix = useFeatureFlag('enableDirectoryHeaderCompatibilityFix');

  const appInfo = getRawLocalStorage<AppInfoStorage>(storageKeys.appInfo.name);
  const lang = getRawLocalStorage<LangStorage>(storageKeys.lang.name);

  let directory = '';
  let redirectUrl: string | null = null;

  if (appInfo?.directoryURL) {
    const rawUrl = new URL(appInfo.directoryURL);
    const params = new URLSearchParams(window.location.search);
    const isMobile = params.get('mobile') === 'true';

    const url = new URL(rawUrl.origin + rawUrl.pathname);
    url.searchParams.set('lang', lang?.langFile ?? 'en');

    if (isMobile) {
      url.searchParams.set('mobile', 'true');
      url.searchParams.set('header', 'false');
      redirectUrl = url.toString();
    } else {
      url.searchParams.set('source', 'true');
      url.searchParams.set('header', 'false');
      directory = url.toString();
    }
  }

  useEffect(() => {
    if (redirectUrl) {
      window.location.replace(redirectUrl);
    }
  }, [redirectUrl]);

  return (
    <div className={clsx('directoryContainer', { 'compatibility-fix-enabled': enableHeaderCompatibilityFix })}>
      <DirectoryHeader className="header" enableHeaderCompatibilityFix={enableHeaderCompatibilityFix}>
        <BackButton useHistory={false} text={i18n.translate('general.back')} />
        <img
          src={`https://s3.amazonaws.com/developertool/${import.meta.env.VITE_APP_ID}/logo_white.png`}
          className="logo"
          alt="logo"
        />
      </DirectoryHeader>
      <iframe
        key={directory}
        src={directory}
        id="inlineFrameExample"
        width="100%"
        height={enableHeaderCompatibilityFix ? '100%' : '99.5%'}
        title="Directory"
      />
    </div>
  );
}

export default LegacyDirectory;
